import image1 from "../../../Assets/Home/AboutUs/aboutus4.png";
import image2 from "../../../Assets/Home/AboutUs/aboutus2.jpg";
import image3 from "../../../Assets/Home/AboutUs/aboutus3.jpg";

import signature from "../../../Assets/Home/AboutUs/signature.png";
import doctor from "../../../Assets/Home/AboutUs/doctor.jpg";
import { useNavigate } from "react-router-dom";
import HeadingTexts from "../../common/HeadingTexts";

const AboutUs = () => {
  const navigate = useNavigate();

  return (
    <div className="grid lg:grid-cols-2 grid-cols-1 bg-[#fafafa] md:px-10 gap-5 px-6 py-6">
      <div className="flex flex-col items-center">
        <div className="flex flex-col md:flex-row items-center gap-6">
          <figure className="polygon-clip w-80 lg:w-60 xl:w-80 h-auto">
            <img
              src={image1}
              className="w-full h-full object-cover object-center"
              data-aos={"fade-right"}
            // data-aos-duration="700"
            // data-aos-offset="100"
            />
          </figure>
          <figure className="polygon-clip w-80 lg:w-60 xl:w-80 h-auto">
            {" "}
            <img
              src={image2}
              className="w-full h-full object-cover object-center"
              data-aos={"fade-left"}
            />
          </figure>
        </div>
        {/* <figure className="polygon-clip w-80 md:-mt-5 mt-5 lg:w-60 xl:w-80 h-auto">
          <img
            src={image3}
            className="w-full h-full object-cover object-center"
            data-aos={"zoom-in"}
          />
        </figure> */}
      </div>
      <div
      >
        <HeadingTexts
          label="About us"
          text="Redefining Diagnostic Excellence"
          bluetext="with Precision and Trust"
        />
        <p data-aos="fade-up" data-aos-duration="700" className="text-sm md:text-[1rem] font-normal leading-relaxed max-w-2xl text-[#5a5a5a] mb-5">
          Diagnonext Labs Pvt Ltd is a high-end pathology laboratory dedicated
          to delivering accurate, reliable, and timely diagnostic services
          across India. Led by experienced pathologists and industry leaders and
          equipped with state-of-the-art laboratory technology, we ensure
          precision, reliability, and trust in every report. Our commitment to
          quality, affordability, and patient-centric care makes us a preferred
          partner for individuals, hospitals, clinics, and healthcare providers.
        </p>
        {/* <div className="grid md:grid-cols-2 grid-cols-1">
          <div data-aos="fade-up" data-aos-duration="700">
            <img src={signature} />
          </div>
          <div data-aos="fade-up" data-aos-duration="700" className="flex items-center gap-4">
            <div>
              <img src={doctor} className="h-20 w-20 rounded-full" />
            </div>
            <div>
              <h1 className="text-xl font-bold familjen-font text-black">
                Dr. Abigail George
              </h1>
              <p className="text-primaryColor">Laboratory Specialist</p>
            </div>
          </div>
        </div> */}
        <button data-aos="fade-up" data-aos-duration="700"
          onClick={() => {
            navigate("/about");
            window.scrollTo(0, 0);
          }}
          className="uppercase familjen-font bg-black text-white rounded-sm py-4 font-semibold px-8 mt-5"
        >
          More About Us
        </button>
      </div>
    </div>
  );
};

export default AboutUs;
